import axios from 'axios'
import { SHELL_URL } from 'common/constants/env'
import accountApi from 'common/infra/accountApi'
import {
  IAccountService,
  SessionReliabilityInferOptions,
  TGetSessionReliabilityInferResult,
} from './types'

const AccountService: IAccountService = {
  getSeller: () => {
    return accountApi.get('/v2/auth')
  },
  getSellerPermissions: () => {
    return accountApi.get('/v2/auth/permissions')
  },
  getServices: () => {
    return axios.get(`${SHELL_URL}menu.json`)
  },
  getIntegratorApplications: (platformName: string) => {
    return accountApi.get(`/v3/integrator-app?search=${platformName}`)
  },
  getExternalIdpaToken: () => {
    return accountApi.get('/v2/auth/external-idpa-token')
  },
  /**
   * Infere a confiabilidade da sessão do usuário com base em uma chamada ao serviço `maas-account`.
   *
   * @returns {Promise<{ result: "TRUSTED" | "UNTRUSTED" | "UNDETERMINED" }>} - Retorna um objeto indicando se a sessão é confiável.
   *
   * @description Faz uma chamada ao serviço `maas-account` para verificar permissões do usuário.
   * Se o serviço retornar sucesso, inferimos que a sessão é "TRUSTED", indicando que possivelmente
   * passou por uma análise de segurança. Caso contrário, se ocorrer um erro com status 403 e
   * código -2403, a sessão é marcada como "UNTRUSTED". Outros erros são tratados como sessão confiável.
   */
  getSessionReliabilityInfer: async (): Promise<TGetSessionReliabilityInferResult> => {
    const TMX_CODE = -2403

    try {
      // Faz uma chamada ao `maas-account`; sucesso implica que a sessão é confiável
      await AccountService.getSellerPermissions()
      return { result: SessionReliabilityInferOptions.TRUSTED, message: '' }
    } catch (error) {
      const hasHttpError = Object.prototype.hasOwnProperty.call(error, 'response')

      // Analisa erro específico para inferir que a sessão é "UNTRUSTED"
      if (hasHttpError && error.response.status === 403 && error.response.data.code === TMX_CODE) {
        return {
          result: SessionReliabilityInferOptions.UNTRUSTED,
          message: error.response.data.message,
        }
      }
      return { result: SessionReliabilityInferOptions.UNDETERMINED, message: '' } // Outros erros não comprometem a confiança da sessão
    }
  },
}

export default AccountService
